import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { FieldTextInput, OutsideClickHandler } from '../../../../components';
import css from './ETADropdown.module.css';
import { DEFAULT_ETA } from '../../../../util/types';
import IconCollection from '../../../../components/IconCollection/IconCollection';

const ETADropdown = ({ formId, formApi }) => {
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  return (
    <OutsideClickHandler className={css.fieldContainer} onOutsideClick={() => setIsOpen(false)}>
      <FieldTextInput
        id={`${formId}eta`}
        name="eta"
        className={css.input}
        type="text"
        label={intl.formatMessage({ id: 'EditListingDetailsForm.eta' })}
        onClick={toggleDropdown}
      />

      {/* <span className={css.dropdownArrow}>
        {isOpen ? (
          <IconCollection className={css.openedSvg} icon="icon-arrow-up-black" />
        ) : (
          <IconCollection icon="icon-arrow-down-black" />
        )}
      </span> */}

      {isOpen && (
        <div className={css.dropdownMenu}>
          {DEFAULT_ETA.map((label, index) => (
            <div
              key={`${label}-${index}`}
              className={css.dropdownCategory}
              onClick={() => {
                formApi.change('eta', label);
                setIsOpen(false);
              }}
            >
              {label}
            </div>
          ))}
        </div>
      )}
    </OutsideClickHandler>
  );
};

export default ETADropdown;
